// extracted by mini-css-extract-plugin
var _1 = "WidgetContentFilesImagesList-moduleitemsContainer__moZFJ WidgetContentItemsList-moduleitemsContainer__QKSlj";
export { _1 as "itemsContainer" }
